exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/index.js??postcss!../../../node_modules/font-awesome/css/font-awesome.css"), "");

// module
exports.push([module.id, "\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Jesussandrea/Documents/proyectos/ngsquare/src/app/registro/registro.component.css
// module id = ../../../../../src/app/registro/registro.component.css
// module chunks = main